// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';

interface DarkLightModeContextProps {
  onToggleDark: () => void;
  isDark: boolean;
}

export const DarkLightModeContext = React.createContext({} as DarkLightModeContextProps);

export const useDarkLightMode = () => React.useContext(DarkLightModeContext);
